// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"191":"21257a65","220":"51b67f88","936":"19a583f9"}[chunkId] + ".chunk.css";
};